import React, { useContext, useState } from 'react';
import Button from '@mui/material/Button';
import { ContextSignUp } from '../../contexts/SignUpContext';
import HotelsTypeahead from './HotelsTypeahead';
import { validateForm } from '../../utils/validateForms';
import useTranslate from '../../customHooks/useTranslate';
import Card from '../../muiComponents/Card';

const SignUpStep1 = () => {
    const translate = useTranslate();
    const { inputsData, setStep } = useContext(ContextSignUp);
    const [errors, setErrors] = useState({});
    const [isValidated, setIsValidated] = useState(false);

    const fieldsToValidate = {
        HotelName: {
            value: inputsData.HotelName,
            validators: ['requiredString'],
        },
    };

    const hadleNextStep = async () => {
        setIsValidated(true);
        const validationErrors = validateForm(fieldsToValidate);
        let newErrors = {};
        for (let newError of validationErrors) {
            newErrors[newError.inputKey] = newError.errorMessage;
        }
        setErrors(newErrors);
        const isValid = validationErrors.length === 0;
        if (isValid) {
            setStep(prev => prev + 1);
        }
    };

    const handleValidate = () => {
        if (isValidated) {
            const validationErrors = validateForm(fieldsToValidate);
            let newErrors = {};
            for (let newError of validationErrors) {
                newErrors[newError.inputKey] = newError.errorMessage;
            }
            setErrors(newErrors);
        }
    };

    return (
        <div className='step-content__container gap-20'>
            <Card className='padding30'>
                <HotelsTypeahead
                    onBlur={handleValidate}
                    error={errors.HotelName}
                />
            </Card>
            <Button
                variant='contained'
                onClick={() => hadleNextStep()}
                style={{ alignSelf: 'flex-end' }}
            >
                {translate('next')}
            </Button>
        </div>
    );
};

export default SignUpStep1;
